<template>
<div>
  <v-btn :disabled="disabled" color="primary" @click="open" text><v-icon class="mr-2">fas fa-file-export</v-icon> Exportar</v-btn>
  <v-dialog v-model="dialog" max-width="520">
    <v-card>
      <v-card-title>
        <h1 class="text text-h5 titulo"><v-icon class="mr-2">fas fa-download</v-icon>Exportar documentos</h1>
      </v-card-title>
      <v-card-text>
        <div class="caption grey--text mb-3">Selecciona el período a exportar (máximo 12 meses). Se aplican además los filtros activos de la tabla.</div>
        <v-chip-group v-model="preset" mandatory active-class="primary--text" column @change="applyPreset">
          <v-chip v-for="p in presets" :key="p.value" :value="p.value" small outlined>{{ p.text }}</v-chip>
        </v-chip-group>
        <v-row dense class="mt-2">
          <v-col cols="6">
            <v-text-field v-model="start" type="date" label="Desde" dense outlined @input="preset = 'custom'" />
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="end" type="date" label="Hasta" dense outlined @input="preset = 'custom'" />
          </v-col>
        </v-row>
        <v-alert v-if="rangeError" type="warning" dense text class="mb-0">{{ rangeError }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">Cancelar</v-btn>
        <v-btn color="success" :loading="loading" :disabled="!!rangeError" @click="download">
          <v-icon small class="mr-2">fas fa-download</v-icon> <b>Descargar CSV</b>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import notifications from '@/utils/notifications'
import { exportDTE } from '@/api/salesNotes'
import moment from 'moment'

const FMT = 'YYYY-MM-DD'
const MAX_DAYS = 366

export default {
  name: "ExportInvoices",
  props: ['filter', 'options', 'disabled', 'activeTab', 'search'],
  data() {
    return {
      dialog: false,
      loading: false,
      preset: 'this_month',
      start: null,
      end: null,
      presets: [
        { value: 'this_month', text: 'Mes actual' },
        { value: 'last_month', text: 'Mes anterior' },
        { value: 'last_3', text: 'Últimos 3 meses' },
        { value: 'this_year', text: 'Año actual' },
        { value: 'custom', text: 'Personalizado' },
      ],
    }
  },
  computed: {
    rangeError() {
      if (!this.start || !this.end) return 'Debes indicar fecha de inicio y término.'
      const s = moment(this.start, FMT), e = moment(this.end, FMT)
      if (e.isBefore(s)) return 'La fecha de término es anterior a la de inicio.'
      if (e.diff(s, 'days') > MAX_DAYS) return 'El período no puede superar 12 meses.'
      return null
    },
  },
  methods: {
    open() {
      // Si la tabla ya tiene un rango de fechas filtrado, se propone ese rango
      const after = this.filter && this.filter.created_after
      const before = this.filter && this.filter.created_before
      if (after && before) {
        this.preset = 'custom'
        this.start = after
        this.end = before
      } else {
        this.preset = 'this_month'
        this.applyPreset('this_month')
      }
      this.dialog = true
    },
    applyPreset(value) {
      const today = moment()
      const ranges = {
        this_month: [today.clone().startOf('month'), today.clone()],
        last_month: [today.clone().subtract(1, 'month').startOf('month'), today.clone().subtract(1, 'month').endOf('month')],
        last_3: [today.clone().subtract(2, 'months').startOf('month'), today.clone()],
        this_year: [today.clone().startOf('year'), today.clone()],
      }
      if (!ranges[value]) return
      this.start = ranges[value][0].format(FMT)
      this.end = ranges[value][1].format(FMT)
    },
    buildParams() {
      const { sortBy, sortDesc } = this.options || {}
      let ordering = '-date_emited,-created_at'
      if (sortBy && sortBy.length && sortBy[0]) {
        let field = sortBy[0]
        if (field === 'customer_name') field = 'rznSocRecep'
        const prefix = sortDesc && sortDesc.length && sortDesc[0] ? '-' : ''
        ordering = field === 'date_emited' ? `${prefix}date_emited,${prefix}created_at` : `${prefix}${field}`
      }

      let sellerFilter = (this.filter && this.filter.seller) || ''
      if (!this.$can('readAll', 'SalesNote')) {
        sellerFilter = this.$store.getters.getUser.id
      }

      let tipoParam = (this.filter && this.filter.tipo) || ''
      if (!tipoParam && this.activeTab && this.activeTab !== 'all') {
        tipoParam = this.activeTab
      }

      return [
        `ordering=${ordering}`,
        `search=${encodeURIComponent(this.search || '')}`,
        `tipo=${tipoParam || ''}`,
        `source=${(this.filter && this.filter.source) || ''}`,
        `emited_after=${this.start}`,
        `emited_before=${this.end}`,
        `seller=${sellerFilter || ''}`,
        `not_null=${(this.filter && this.filter.not_null) || ''}`,
      ].join('&')
    },
    async download() {
      if (this.rangeError) return
      this.loading = true
      try {
        await exportDTE(this.buildParams())
        notifications.showSuccess('Documentos Exportados')
        this.dialog = false
      } catch (err) {
        notifications.showError('Error Exportando Documentos ' + err)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
